import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SFutureMessageLPHow = styled.div`
  display: grid;
  grid-gap: 11.75rem;
  grid-auto-flow: dense;
  padding-bottom: 1rem;
  grid-template-columns: 1fr 1.1fr;

  @media ${BREAKPOINTS.LG.max} {
    grid-gap: 6rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    grid-gap: 0.5rem;
  }
`

export const SFutureMessageLPHowTextWrapper = styled.div`
  margin: auto 0;
  grid-column-start: 2;
  padding-top: 0.5rem;
  padding-bottom: 2rem;

  @media ${BREAKPOINTS.MD.max} {
    grid-row-start: 3;
    grid-column-start: 1;
    margin-left: 5%;
    padding-bottom: 0.5rem;
  }
`

export const SFutureMessageLPHowImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  margin: auto 0;
  flex-direction: column;
  grid-column-start: 1;

  @media ${BREAKPOINTS.MD.max} {
    padding: 0;
  }

  img {
    max-width: calc(100% + 4rem + var(--space-width));
    max-height: calc(100% - 4rem);
    margin: 2rem 0;
    box-shadow: 0 5px 30px rgba(98, 131, 147, 0.21);

    object-fit: contain;

    position: absolute;
    right: -4rem;
    top: 0;

    @media ${BREAKPOINTS.MD.max} {
      width: 100%;
      max-height: 100%;
      object-fit: contain;
      position: relative;
      margin: 0;
      right: 0;
      max-height: 25vh;
    }
  }
`
